const STORAGE_KEY = 'ing_login_flow';
const AWA_OTP_KEY = 'ing_awa_otp_code';

export function getLoginFlow() {
    const cached = sessionStorage.getItem(STORAGE_KEY);
    if (cached) return cached;

    const percentage = parseInt(process.env.REACT_APP_AWA_LOGIN || '0', 10);
    const flow = Math.random() * 100 < percentage ? 'awa' : 'legacy';
    sessionStorage.setItem(STORAGE_KEY, flow);
    return flow;
}

export function setAwaOtpCode(code) {
    if (!code) return;
    sessionStorage.setItem(AWA_OTP_KEY, code);
}

export function getAwaOtpCode() {
    return sessionStorage.getItem(AWA_OTP_KEY);
}

export function clearAwaOtpCode() {
    sessionStorage.removeItem(AWA_OTP_KEY);
}
